import { useEffect, useState } from 'react';

import { useInatoHealthCheckService } from '../../InatoHealthCheckContext';
import { SomethingUnexpectedHappened } from './SomethingUnexpectedHappened';
import { SomethingWentWrong } from './SomethingWentWrong';

const useCheckInatoConnection = () => {
  const InatoHealthCheckService = useInatoHealthCheckService();
  const [status, setStatus] = useState<'checking' | 'ok' | 'unreachable'>(
    'checking',
  );
  useEffect(() => {
    const checkHealth = async () => {
      if (await InatoHealthCheckService.ok()) {
        setStatus('ok');
      } else {
        setStatus('unreachable');
      }
    };
    checkHealth();
  }, [InatoHealthCheckService]);

  return status;
};

export const UnexpectedError = () => {
  const checkInatoConnection = useCheckInatoConnection();

  switch (checkInatoConnection) {
    case 'checking':
      return null;
    case 'unreachable':
      return <SomethingWentWrong />;
    case 'ok':
    default:
      return <SomethingUnexpectedHappened />;
  }
};
